<template>
  <!-- -->
  <div class="image-data-setting mini-component">
    <div class="desc">
      热销商品必须放置在最后一行，否则无法正常加载多页数据。热销商品的数据不需要在组件中设置，而是在商城/商品推荐中设置。热销商品的设置功能，暂不支持跳转功能设置，所有商品的点击行为将统一跳转至商品页
    </div>
    <alone-data v-model="settingData" @change="changeData" :show-icon="false" :show-tag="false" :show-background="false" :show-image="false"/>
  </div>
</template>

<script>

import AloneData from "@/views/h5/common/sys/miniProgram/setting/component/AloneData.vue";
export default {
  emits: ["change"],
  props: {
    data: {
      type: Object,
      default: () => {
        return {componentData: {}}
      }
    }
  },
  name: "",
  components: {
    AloneData
  },
  data() {
    return {
      settingData: {},
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!this.data.componentData) {
        this.settingData = {size: ""};
      } else {
        this.settingData = this.data.componentData;
      }
    },
    changeData() {
      this.$emit("change", {...this.data, componentData: this.settingData});
    }
  }
};
</script>

<style lang="scss" scoped>
.image-data-setting{

}
</style>